;(function($, trackFindaEvents){
    'use strict';

    var rnn = window.rnn;

    function eventContactForm() {
        /*Show contact form */
        var $btnShowContactForm = $('#btnShowContactForm, #btnCancelContactForm'),
            $dvContactForm = $('#dvContactForm');

        $btnShowContactForm.on('click', function() {
            $dvContactForm.toggleClass('hide');
            $dvContactForm.find('#id_name').focus();
            return false;
        });
    }

    function checkSearchURL() {
        var keywords = window.location.href.slice(window.location.href.indexOf('?keywords')),
            $classifiedsSearch = $('#classifiedsSearch');

        if(keywords.length > 1){
            //Have used search form.
            $classifiedsSearch.removeClass('hide');
        }
    }

    function genLargeLinks(){
        // need the actual divs to be links on mobile.
        $('.largeAdLink').each(function() {
            //var currentAdURL = $(this).parent.parent.data('resultUrl');

            var $this = $(this),
                $currentAdURL = $this.data('resultUrl');

            $(this).click(function(){
                window.location = $currentAdURL;
            });
        });

        $('#adDetail .contact-bar .email, .adNavHelper .email').click(function() {
            var $form = $('#contact-form-container');
            $('html, body').animate({
                scrollTop: $form.offset().top - 50
            }, 400);
        });

        $('#adDetail #id_accurate_information_confirmation').prop('checked', true);
    }

    function customFormEls(){
        // As the contact form on the ad detail page is BE generated, this ads in some extra elements for some nice UI.
        $("#adContactForm input").each(function() {
            var $elID = $(this).attr('id');
            var $elClass = $(this).attr('class');

            if($elID === "id_name"){
                $(this).attr( "placeholder", "Name" );
            }else if($elID === "id_email"){
                $(this).attr( "placeholder", "Email" );
            }else if($elID === "id_phone_number"){
                $(this).attr( "placeholder", "Phone Number" );
            }else if($elClass === "captchaInput"){
                $(this).attr( "placeholder", "Security Code" );
            }else if($elClass === "input-large"){
                $(this).attr( "placeholder", "Your Resume" );
            }
        });

        $("#adContactForm textarea").each(function() {
            var $elID = $(this).attr('id');
            if($elID === "id_message"){
                $(this).attr( "placeholder", "Message..." );
            }
        });

        $("#adContactForm label").each(function(){
            var txtRemoveColons = $(this).text().replace(':','');
            $(this).text(txtRemoveColons);
        });
    }

    function shuffle(sourceArray) {
        for (var n = 0; n < sourceArray.length - 1; n++) {
            var k = n + Math.floor(Math.random() * (sourceArray.length - n));
            var temp = sourceArray[k];
            sourceArray[k] = sourceArray[n];
            sourceArray[n] = temp;
        }
        return sourceArray;
    }

    function removeObselete(sourceArray){
        // Sometimes the data we receive will have no suburb set. For feature properties, we don't want to show that
        // item in the listings, so we'll remove where appropriate.

        var currentSuburb;

        for (var n = 0; n < sourceArray.length - 1; n++) {
            currentSuburb = sourceArray[n].address.suburb;
            if(currentSuburb === false){
                sourceArray.splice(n,1);
            }
        }

        return sourceArray;
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function backToResult() {
        var $searchPage = $('.search-results.mapArea'),
            $backToResult = $('.back-to-result'),
            $motoringDetailPage = $('.ads-detail'),
            searchResultClassifieds = 'SearchResultClassifiedsUrl';

        //Save a cookie in search classifieds page.
        if($searchPage.length > 0) {
            Cookies.set(searchResultClassifieds, window.location.href, { path: '/', expires: 1 });
        }

        //Bind event back to result page in detail classifieds page
        if ($motoringDetailPage.length > 0) {
            var searchResultUrl = Cookies.get(searchResultClassifieds);

            //Check if cookie is null then hide button back to result
            if(!searchResultUrl) {
                $backToResult.hide();
                return false;
            }

            //Bind click event back to result button
            $backToResult.on('click', function() {
                //Back to url cookie
                window.location.href = searchResultUrl;
                Cookies.remove(searchResultClassifieds);
                return false;
            });
        }
    }

    function hideEmptyAccordion(){

        var $accordionInner = $('.panel-group .panel-body');

        $accordionInner.each(function(){
            var $innerContent = $('.control-group, ul', $(this));

            if($innerContent.length === 0){
                $(this).parents('.panel').remove();
            }
        });
    }

    function callPhoneNumber(phoneNumber) {
        phoneNumber = phoneNumber.replace(/\s+/g, '');
        window.location.href = 'tel://' + phoneNumber;
    }

    function clickPhoneNumber(){
        $("[data-click-to-call]").click(function() {
            var phoneNumber = atob($(this).data('click-to-call'));
            trackFindaEvents.track_phoneclick($(this));
            callPhoneNumber(phoneNumber);
        });

        $('.adNavHelper [data-phone-hidden="true"]').click(function(){
            var number = $(this).data('phone-number');
            $(this).find('.number').html(number);
        });
    }

    function clickAdvertiserDetails() {
         $("[data-click-advertiser-details]").click(function() {
            var $this = $(this);
            // we only want to send th event when the contact expands (not when it collapses)
            if (!$this.next().hasClass('expanded')) {
                trackFindaEvents.track_advertisercontactclick($this);
            }
        });
    }

    function displayHeaderSuffix(){
        var jqHeaderSuffix = $('.classifiedsHeader .result-price-suffix');

        if(jqHeaderSuffix.width() > 250)
            jqHeaderSuffix.addClass('show');
    }

    function goToContactForm(){
        var jqContactForm = $('#contact-form-container'),
            jqInputName = $('#id_name',jqContactForm),
            jqAlertBox = $('.alert');

        var expandContactForm = function() {
            if(!jqContactForm.hasClass('in'))
            {
                jqContactForm.addClass('in').css('height','auto');
            }

            $('html, body').animate({
                scrollTop: jqContactForm.offset().top - 50
            }, 400);

            jqInputName.focus();
        };

        jqContactForm.on('shown', function () {
            jqInputName.focus();
        });

        if(jqAlertBox.length > 0 && jqContactForm.length > 0){
            expandContactForm();
        }

        if($('[data-error-for="resume"]').length > 0)
            $('.resume').addClass('error');

        $('.goToContactForm, a[href="#dvContactForm"]').on('click', function(e) {
            e.preventDefault();
            expandContactForm();
        });

        // from search results
        $('.openContactForm').click(function() {
            var url = $(this).data('link');
            window.location.href = url + '#expandContactForm';
        });

        if (window.location.hash.indexOf('expandContactForm') > -1) {
            expandContactForm();
        }
    }

    function contactFormOnBlurChecks(){
        $('#adContactForm input, #adContactForm textarea').blur(function() {
            var $this = $(this);
            if($this.val()){
                $this.addClass('filled');
            }else{
                $this.removeClass('filled');
            }
        });

        $('#adContactForm input').each(function(){
            if($(this).val() !== "")
                $(this).addClass('filled');
        });

        $('#adContactForm textarea').each(function(){
            if($(this).val() !== "")
                $(this).addClass('filled');
        });
    }

    function doFeatureSearchForm(inputEl){
        var $inputEl = $(inputEl);

        var $dataPillar = $inputEl.closest('.feature-ad-container').data('pillar'),
            pillars = $dataPillar.split('_'),
            pillar,
            classification = '',
            $fragCategory = $inputEl.parent().data('category') || '',
            $fragClassification = $inputEl.parent().data('classification') || '',
            $value = $inputEl.val(),
            path = window.location.host,
            region = rnn.modules.utilities.slugify(rnn.site.primaryRegion.name),
            constructedURL;

        if(pillars.length === 2 && $value.length){
            pillar = $fragCategory.length ? $fragCategory : pillars[0];
            classification = $fragClassification.length ? '/' + $fragClassification : '';

            constructedURL = window.location.protocol+'//' + path + '/classifieds/' + region + '/' + pillar + classification + '/?keywords=' + $value;
            window.location = constructedURL;
        }else if($value.length){
            //search whole of classifieds
            constructedURL = window.location.protocol+'//' + path + '/classifieds/' + region + '/?keywords=' + $value;
            window.location = constructedURL;
        }
    }

    function featureAdSearch(){
        $('.feature-ad-container .search-form input').keypress(function(event){
            var keycode = (event.keyCode ? event.keyCode : event.which);

            if(keycode == '13'){
                doFeatureSearchForm(this);
            }
        });
    }

    function rePositionMotoringTitleIcons(){
        var $transmission = $('.transmission-type-icon'),
            $body = $('.body-type-icon'),
            $odometer = $('.odometer-icon');

        $('.acf-list').append($transmission).append($body).append($odometer);
    }

    function placeAdForm() {
        if ($('.classifiedsPlaceAdForm').length > 0) {
            $('.classifiedsPlaceAdForm .placeholder').find('input, textarea').each(function () {
                var $label = $(this).siblings('label');
                $(this).attr('placeholder', $label.text());
            });
        }
    }

    function genTrackingLinks(){
        // some links need to be set after the template has rendered.
        $('#adDetail .hiddenPhone').click(function() {
            trackFindaEvents.track_phoneclick($(this));

            if(!$(this).hasClass('expanded')){
                $(this).addClass('expanded');
            }else{
                var phoneNumber = atob($(this).data('click-b64'));
                callPhoneNumber(phoneNumber);
            }

        });

        $('#adDetail .phone, #adDetail .phone-meta, .dealerPage .phone').click(function() {
            trackFindaEvents.track_phoneclick($(this));
        });

        $('.website-gaTrack').click(function(){
            trackFindaEvents.track_websiteclick($(this));
        });
    }

    function showDetailWidgets(){
        $('#adDetail .detail-widget').each(function() {
            var $this = $(this);
            if(!!$this.find('.control-group').length){
                $this.removeClass('hide');
            }
        });
    }

    function truncateAdText(){
        $('.read-more').click(function(){
            var $el = $('.result-text');

            if($el.hasClass('expanded')){
                $el.animate({
                    height: 100
                }, 500, function() {
                    // Animation complete.
                    $el.toggleClass('expanded');
                    $('#adDetail .description .read-more span').html('Read more');
                    $('#adDetail .description .read-more .arrow-up')
                        .removeClass('arrow-up')
                        .addClass('arrow-down');
                });
            }else{
                $el.animate({
                    height: $el.get(0).scrollHeight
                }, 500, function() {
                    // Animation complete.
                    $el.toggleClass('expanded');
                    $('#adDetail .description .read-more span').html('Read less');
                    $('#adDetail .description .read-more .arrow-down')
                        .removeClass('arrow-down')
                        .addClass('arrow-up');
                });
            }
        });

        var element = $('#adDetail .result-text')[0];

        if(element){
            var ifTruncate = function(element) {
                if (element.offsetHeight < element.scrollHeight ||
                    element.offsetWidth < element.scrollWidth) {
                    $('.result-text').height('100px');
                    $('.result-text').removeClass('max-height');
                    $('#adDetail .description .read-more').removeClass('hide');
                } else {
                    $('.result-text').height('');
                    $('.result-text').addClass('max-height');
                    $('#adDetail .description .read-more').addClass('hide');
                }
            };

            ifTruncate(element);
            $(window).resize(function() {
                ifTruncate(element);
            });
        }
    }

    function advertiserPage() {
        if ($('.dealerPage').length > 0) {

            $('.dealerPage #categorySelect').on('change', function () {
                document.location.href = $(this).val();
            });

        }
    }

    function initClassifieds(){
        checkSearchURL();
        genLargeLinks();
        customFormEls();
        rePositionMotoringTitleIcons();
        backToResult();
        hideEmptyAccordion();
        clickPhoneNumber();
        displayHeaderSuffix();
        goToContactForm();
        contactFormOnBlurChecks();
        featureAdSearch();
        placeAdForm();
        clickAdvertiserDetails();
        genTrackingLinks();
        showDetailWidgets();
        truncateAdText();
        advertiserPage();
    }

    rnn.modules.register('classifieds', {
        init: initClassifieds
    });

})(jQuery, window.rnn.modules.trackFindaEvents);
